import React from "react";
import { auth, provider, database } from "../../firebase";
import LoginContext from "../../context/LoginContext";
import NavBar from "../widgets/NavBar2";

import {
  Box,
  Flex,
  Text,
  Input,
  Button,
  Checkbox,
  Link
} from "@chakra-ui/react";

import { Link as NavLink } from "react-router-dom";

export default function SignUp() {
  const isLogin = React.useContext(LoginContext);
  const [disableButton, setDisableButton] = React.useState(true);
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");

  const signup = () => {
    auth
      .createUserWithEmailAndPassword(email, password)
      .then((userCredential) => {
        console.log(auth.currentUser);
        // send verification mail.
        userCredential.user.sendEmailVerification();

        auth.signOut();

        alert("Email sent to " + email + ".");
      })
      .catch(alert);
  };

  const googleSignin = () => {
    auth
      .signInWithPopup(provider)
      .then(function (result) {
        console.log(auth);
        if (
          auth.currentUser.metadata.creationTime ===
          auth.currentUser.metadata.lastSignInTime
        ) {
          database.collection("users").add({
            uid: auth.currentUser.uid,
            name: auth.currentUser.displayName,
            email: auth.currentUser.email,
            photoUrl: auth.currentUser.photoURL
          });
        }
        isLogin.userInfo({
          displayName: auth.currentUser.displayName,
          email: auth.currentUser.email,
          photoUrl: auth.currentUser.photoURL
        });
        isLogin.login();
      })
      .catch(alert);
  };

  return (
    <Flex flexDirection="column">
      <NavBar />
      <Flex flexDirection="Column" align="center" height="600px" mt="10">
        <Text fontFamily="sans-serif" fontWeight="bold" fontSize="18" mt="10">
          Hello, welcome to Astroworkers
        </Text>
        <Text
          marginTop={12}
          fontFamily="sans-serif"
          fontWeight="bold"
          fontsize="18">
          Sign Up
        </Text>
        <Input
          placeholder="Enter your name"
          width="310px"
          focusBorderColor="blue.500"
          marginTop={4}
        />
        <Input
          placeholder="Enter your email"
          type="email"
          width="310px"
          focusBorderColor="blue.500"
          marginTop={4}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
        <Input
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              signup();
            }
          }}
          placeholder="Enter your password"
          type="password"
          width="310px"
          focusBorderColor="blue.500"
          marginTop={4}
          marginBottom={7}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
        />
        <Checkbox
          size="sm"
          marginBottom={7}
          onChange={() => {
            setDisableButton((value) => {
              setDisableButton(!value);
            });
          }}>
          I agree to{" "}
          <Link as={NavLink} to="/terms" color="blue.500">
            Astroworker’s TOS
          </Link>{" "}
          and{" "}
          <Link as={NavLink} to="/privacy" color="blue.500">
            Privacy Policy
          </Link>
        </Checkbox>
        <Button onClick={signup} colorScheme="blue" isDisabled={disableButton}>
          Sign Up with Email
        </Button>
        <Text margin={3}>Or</Text>
        <Button
          onClick={googleSignin}
          colorScheme="red"
          marginBottom="2"
          isDisabled={disableButton}>
          Sign in with Google
        </Button>
        <Text marginTop={5}>
          Have an account?{" "}
          <Link as={NavLink} to="/login" color="blue.500">
            Login now
          </Link>
        </Text>
      </Flex>
    </Flex>
  );
}
